export default "__VITE_ASSET__C1X10xOa__"